import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import ShadowBox from 'components/ShadowBox'
import formatCurrency from 'utils/formatCurrency'
import './styles.sass'

const UserCoupon = ({ userCoupon: { coupon } }) => (
  <ShadowBox className={cx('user-coupon', coupon.expired && 'is-expired')} pad>
    <div className="coupon-info">
      <div className="friendly-name">
        {coupon.friendlyName || coupon.id}
      </div>
      {coupon.description &&
        <div className="description">{coupon.description}</div>
      }
    </div>
    <div className="off-info">
      <div className="off-value">
        {coupon.offType.type === 'AMOUNT_OFF'
          ? formatCurrency(coupon.offType.amountOff)
          : coupon.offType.percentOff + '%'
        } off
      </div>
      {coupon.dateExpires && (
        coupon.expired
          ? (
            <div className="expired">
              Expired
            </div>
          )
          : (
            <div className="expires">
              expires {coupon.dateExpires.format('L LT')}
            </div>
          )
      )}
    </div>
  </ShadowBox>
)

export default observer(UserCoupon)



// WEBPACK FOOTER //
// ./src/client/components/UserCoupon/index.jsx